import { Flex, Form, Input, Select, Tag, Typography } from "antd";
import axios from "axios";
import React, { useState, useEffect } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import GeneralModal from "../General.modal";

import { useTranslation } from "react-i18next";
const UpdateRole = ({ data, employees, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const { Title } = Typography;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const [roleEmployees, setRoleEmployees] = useState([]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        title: data?.title,
        employees: data?.employees?.map(emp => emp?._id)
      });
      fetchEmployeesByRole();
    }
  }, [data]);

  const fetchEmployeesByRole = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/roles/users-by-role/${data?._id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setRoleEmployees(res.data.employees);
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const handleUpdateRole = async values => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/roles/update/${data?._id}`,
        { title: values.title, employees: values.employees },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      Success(t("Role updated successfully!"));
      handleCancel();
      updateParent();
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const handleRemoveRoleFromUser = async id => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/roles/users/remove-role/${data?._id}`,
        { employeeId: id },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      Success(t("Role removed successfully!"));
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const availableEmployees = employees.filter(
    emp => !roleEmployees?.some(roleEmp => roleEmp?._id === emp?.value)
  );

  const items = (
    <>
      <Form form={form} onFinish={handleUpdateRole} layout="vertical">
        {!data?.isDefault && (
          <Form.Item
            name="title"
            label={t("Role Title")}
            rules={[{ required: true, message: t("Role title is required") }]}
          >
            <Input />
          </Form.Item>
        )}

        {roleEmployees?.length > 0 && (
          <div className="mb-3">
            <h6 className="mb-2">{t("Assigned Employees:")}</h6>
            <Flex gap={4} wrap="wrap">
              {roleEmployees?.map(emp => (
                <Tag
                  key={emp?._id}
                  onClose={() => handleRemoveRoleFromUser(emp?._id)}
                  bordered
                  closable
                >
                  {emp?.firstName} {emp?.lastName}
                </Tag>
              ))}
            </Flex>
          </div>
        )}

        <Form.Item name="employees" label={t("Add New Employees")}>
          <Select mode="multiple" options={availableEmployees} />
        </Form.Item>

        {/* <Button type="primary" htmlType="submit">
                        {t("Update")}
                    </Button> */}
      </Form>
    </>
  );

  return (
    <>
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      {/* <Drawer
                title={t("Edit Role")}
                visible={editDrawerVisible}
                onClose={() => setEditDrawerVisible(false)}
                width={400}
            >

            </Drawer> */}
      <GeneralModal
        title={<Title level={4}>{t("Edit Role")}</Title>}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        items={items}
      />
    </>
  );
};

export default UpdateRole;
